import ShellItemModel from './ShellItemModel';

class ShellIHubModel {
  getStartedComponents;
  getStartedVideoUrl;
  isFirstTimeUser;
  onboardingComponents;

  constructor(options = {}) {
    this.getStartedComponents = options.getStartedComponents.map(i => (new ShellItemModel(i)));
    this.getStartedVideoUrl = options.getStartedVideoUrl;
    this.isFirstTimeUser = options.isFirstTimeUser;
    this.onboardingComponents = options.onboardingComponents.map(i => (new ShellItemModel(i)));
  }
}

export default ShellIHubModel;
